import { FolderIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { CreateFolderDialog } from "@fronterahealth/frontera-ui-components";
import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportSectionFieldsType } from "@api/graphql/types-and-hooks";
import { FolderManagementAction } from "@components/GoalsBank/constants";
import { FolderManagementDialog } from "@components/GoalsBank/dialogs/FolderManagementDialog";
import { useSaveToFolder } from "@components/ReportField/ReportFieldDropdownMenu/useSaveToFolder";
import { FormContainer } from "@components/forms/FormLayout";

interface ItemProps {
  onOpen: () => void;
}

export const ReportFieldDropdownMenuSaveToFolderItem: React.FC<ItemProps> = ({ onOpen }) => {
  return (
    <DropdownMenuItem onClick={onOpen}>
      <FolderIcon />
      Save to folder
    </DropdownMenuItem>
  );
};

interface DialogProps {
  field: ReportSectionFieldsType;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ReportFieldDropdownMenuSaveToFolderDialog: React.FC<DialogProps> = ({ field, open, onOpenChange }) => {
  return <SaveToFolderDialogInner field={field} open={open} onClose={() => onOpenChange(false)} />;
};

const SaveToFolderDialogInner: React.FC<{
  field: ReportSectionFieldsType;
  open: boolean;
  onClose: () => void;
}> = ({ field, open, onClose }) => {
  const [isNewFolderDialogOpen, setIsNewFolderDialogOpen] = useState(false);
  const { userType, createNewFolder, formState, RegisteredFormSelected, reset, onSubmit, folderSelections } =
    useSaveToFolder(field, onClose);

  return (
    <FolderManagementDialog
      open={open}
      onCancelClick={() => {
        reset();
        onClose();
      }}
      action={FolderManagementAction.SAVE}
      onSaveClick={onSubmit}
    >
      <FormContainer onSubmit={onSubmit}>
        <RegisteredFormSelected
          formKey="folderId"
          required
          formState={formState}
          items={folderSelections}
          title="Select Folder"
          placeholderText="Select Folder"
          actionItem={{ label: "Create New", onClick: () => setIsNewFolderDialogOpen(true) }}
        />
      </FormContainer>
      <CreateFolderDialog
        open={isNewFolderDialogOpen}
        setOpen={setIsNewFolderDialogOpen}
        userType={userType}
        onCreateFolder={createNewFolder}
      />
    </FolderManagementDialog>
  );
};
